import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { getStatusLabel } from "@/lib/statusLabels";

export default function AdminEmailQueuePage() {
  const [emails, setEmails] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/email-queue");
        setEmails(data);
      } catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Falha ao carregar."); }
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-email-queue-page">
      <div>
        <div className="overline text-accent mb-3">Notificações</div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight">Fila de emails</h1>
        <p className="text-muted-foreground mt-2">Emails disparados automaticamente pelo sistema. Modo demo — configure Resend/SendGrid para envio real.</p>
      </div>

      <div className="bg-card border border-border rounded-sm divide-y divide-border">
        {emails.length === 0 ? (
          <div className="p-10 text-center text-muted-foreground">Nenhum email enviado ainda.</div>
        ) : (
          emails.map((e, i) => (
            <div key={i} className="px-5 py-4 flex items-start gap-4" data-testid={`email-item-${i}`}>
              <Mail className="w-4 h-4 text-primary mt-1" />
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm truncate">{e.subject}</div>
                <div className="text-xs text-muted-foreground">para {e.to} · {new Date(e.created_at).toLocaleString("pt-BR")}</div>
                <div className="text-sm text-muted-foreground mt-2 line-clamp-2">{e.body_text}</div>
              </div>
              <span className={`overline px-2 py-0.5 rounded-sm border ${getStatusLabel("email", e.status).cls}`}>{e.provider} · {getStatusLabel("email", e.status).label}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
